import { toast } from 'react-toastify';

import { AppDispatch } from '..';
import { clearPriceAlerts, fetchPriceAlerts, runPriceAlertTask } from '../../api';
import { Logger } from '../../utils/Logger';

import { success, fail, loading, pending, removeAll, clearing } from './reducer';

export const getPriceAlertsAsync = () => {
  return (dispatch: AppDispatch) => {
    dispatch(loading(true));
    fetchPriceAlerts()
      .then((response) => {
        const priceAlerts = response.data;
        Logger.log(priceAlerts);
        dispatch(success(priceAlerts));
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      });
  };
};

export const clearPriceAlertsAsync = () => {
  return (dispatch: AppDispatch) => {
    dispatch(clearing(true));
    clearPriceAlerts()
      .then((response) => {
        const priceAlerts = response.data;
        Logger.log(priceAlerts);
        dispatch(removeAll());
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      });
  };
};

export const runPriceAlertTaskAsync = () => {
  return (dispatch: AppDispatch) => {
    dispatch(pending(true));
    runPriceAlertTask()
      .then((response) => {
        const alerts = response.data;
        Logger.log(alerts);
        dispatch(success(alerts));
      })
      .catch((error) => {
        const msg = error.response?.data.message || error.message;
        dispatch(fail(msg));
        toast.error(msg);
      });
  };
};
